import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className="ri-film-line text-3xl"></i>
      </span>
      <p className="font-label mt-6 text-5xl font-bold tracking-tight text-primary-900">404</p>
      <h1 className="mt-3 text-xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面可能已被移动或删除，可以返回首页，或直接浏览作品档案。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex min-h-[48px] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex min-h-[48px] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
        >
          <i className="ri-film-line"></i>
          浏览作品
        </Link>
      </div>
    </div>
  );
}